import {GroupingIndicators, GroupingIndicatorsItems} from './groupingIndicators.model';
import {PanelConfigurationIndicators} from './panelConfigurationIndicators.model';
import {Indicator} from '../report/indicator.model';

export class GroupingIndicatorsResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: GroupingIndicators;
}
export class TotalIndicatorsResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: TotalIndicators;
}

export class TotalIndicators {
  panelConfigurationIndicators: PanelConfigurationIndicators;
  indicators: Array<Indicator>;
}
